export const mentionsLegalesContent = {
  title: "Mentions légales",
  updatedAt: "Dernière mise à jour : septembre 2026",
  sections: [
    {
      heading: "Éditeur du site",
      paragraphs: [
        "Le présent site est édité par L. Lobbardi, intervenante à domicile, exerçant sous l'enseigne « Proximité Confiance Finistère ».",
        "Contact : contact@proximiteconfiancefinistere.fr — Téléphone : 06 77 45 38 37.",
      ],
    },
    {
      heading: "Hébergement",
      paragraphs: [
        "Le site est hébergé par Ionos, plateforme de création et d'hébergement de sites web.",
      ],
    },
    {
      heading: "Propriété intellectuelle",
      paragraphs: [
        "L'ensemble des contenus présents sur ce site (textes, photographies, illustrations, logo) est protégé par le droit de la propriété intellectuelle.",
        "Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
      ],
    },
    {
      heading: "Responsabilité",
      paragraphs: [
        "Les informations présentes sur ce site sont fournies à titre indicatif. L'éditeur s'efforce d'en garantir l'exactitude, mais ne saurait être tenu responsable des erreurs ou omissions.",
        "Le site peut contenir des liens vers des sites tiers. L'éditeur n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.",
      ],
    },
    {
      heading: "Données personnelles",
      paragraphs: [
        "Les données collectées via le formulaire de contact sont utilisées uniquement pour répondre à vos demandes. Pour en savoir plus, consultez notre politique de confidentialité.",
      ],
    },
  ],
};